import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=58950822&scoped=true&"
import script from "./Dataset.vue?vue&type=script&lang=js&"
export * from "./Dataset.vue?vue&type=script&lang=js&"
import style0 from "./Dataset.vue?vue&type=style&index=0&id=58950822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58950822",
  null
  
)

export default component.exports